// Auto-generated by splitter.py — do not regenerate; edit directly.

import React, { useState, useEffect } from 'react';

// `suppressErrors` is flipped on by sessionExpired.js once it has told the operator their
// session ended. After that every error toast is a downstream symptom of that one fact
// ("Could not create user", "Could not load orders"…); stacking them buries the one thing
// worth clicking.
export const TOAST_BUS = {
  listeners: [],
  suppressErrors: false,
  push(t) {
    if (t.kind === 'error' && this.suppressErrors) return;
    this.listeners.forEach(l => l(t));
  },
};

// `action` is an optional { label, onClick } — the one thing the operator would do next.
export const toast = (message, kind = 'success', detail, action) => TOAST_BUS.push({ id: Date.now() + Math.random(), message, kind, detail, action });

// Global audit log — every state-changing action in the system funnels through logAudit().
// Uses a module-level mutable array + pub/sub so AuditPage (and any observer) can re-render.

export const AUDIT_BUS = { entries: [], listeners: [], notify() { this.listeners.forEach(l => l()); } };

export const logAudit = (entry) => {
  const now = new Date();
  const enriched = {
    id: 'AL-' + now.getTime().toString(36).toUpperCase(),
    ts: now.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
    rawTs: now.getTime(),
    actor: 'You',
    eventId: '',  // optional — link to event for filtering
    actorId: 'USR-0001',
    ip: '102.51.18.94',
    ...entry,
  };
  AUDIT_BUS.entries.unshift(enriched);
  AUDIT_BUS.notify();
};

export const useAuditLog = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force(x => x + 1);
    AUDIT_BUS.listeners.push(fn);
    return () => { AUDIT_BUS.listeners = AUDIT_BUS.listeners.filter(l => l !== fn); };
  }, []);
  return AUDIT_BUS.entries;
};


/**
 * COPY, AND SAY WHAT ACTUALLY HAPPENED.
 *
 * `navigator.clipboard.writeText` returns a PROMISE and rejects whenever the browser declines —
 * an insecure origin, a document that is not focused, a permission the user denied. Two shapes
 * were in use across this codebase and both report success unconditionally:
 *
 *   navigator.clipboard?.writeText(x); toast('Copied', 'success', x);
 *   try { navigator.clipboard?.writeText(x); toast('Copied', …) } catch { }
 *
 * The second looks defended and is not: a synchronous try/catch cannot catch an async rejection,
 * so it never fires. Either way the operator is told the thing is on their clipboard when it is
 * not — and they find out by pasting nothing into an email to the press.
 *
 * `?.` is kept because `navigator.clipboard` is genuinely undefined on an insecure origin, where
 * calling it would throw synchronously; awaiting `undefined` is fine and falls through to the
 * honest failure below.
 */
export async function copyToClipboard(text, { label = 'Copied', detail } = {}) {
  const value = String(text ?? '');
  try {
    await navigator.clipboard?.writeText(value);
    if (!navigator.clipboard) throw new Error('no clipboard');
    toast(label, 'success', detail ?? value);
    return true;
  } catch {
    // Actionable, because there IS an action: every one of these call sites shows the value on
    // screen next to the button, so selecting it by hand is a real fallback, not a shrug.
    toast('Could not copy', 'warning', 'Your browser blocked the clipboard — select the text on screen and copy it manually.');
    return false;
  }
}
